import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from './useAuthContext';

export function useUsers() {
  const { client } = useAuthContext();
  const result = useQuery({ queryKey: ['users'], queryFn: () => client!.listUsers() });

  return result;
}
